/**
 * Engage Types
 * TypeScript types for Engage Objects (Video, Blog, Education, etc.)
 */

// Matches backend BizPartEngage.Core.Entities.Base.Enums.BizEngageType
export enum BizEngageType {
	NONE = -1,
	/** Online Education / HTML5 */
	Education = 1,
	Blog = 2,
	/** Video / Mediabank file */
	Video = 3,
	SCORM = 4,
	Speedquiz = 5,
	Certification = 6,
	Mission = 7,
	Event = 8,
	External = 999,
}

// Simplified engage object for picker use
export interface EngageObject {
	EstimatedTimeInMinutes: number;
	ImageUrl: string;
	UrlRewrite?: string;
	Status?: number;
	Id: number;
	Name: string;
	Description?: string;
	EngageObjectType: BizEngageType;
	IsActive: boolean;
}
